import React from 'react';
import { X } from 'lucide-react';

const Header = ({ onClose }) => (
  <div className="flex justify-between items-start mb-2">
    <div className="min-w-0">
      <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Step 2 of 2</p>
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">Find a Basket</h2>
    </div>
    <button 
      onClick={onClose} 
      className="p-1.5 -mr-1.5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 active:bg-gray-100 rounded-lg transition-colors touch-manipulation"
      aria-label="Close modal"
    >
      <X size={20} />
    </button>
  </div>
);

export default Header;
